define('social_sharing_flyout.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('social_sharing_flyout', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"social-sharing-flyout-icons\" data-type=\"social-share-icons\"></div>  ";
},"useData":true}, 'extensions/Tavanoteam/TT_Master_Theme/2025.6.1/', 'extensions/Tavanoteam/TT_Master_Theme/2025.6.1/', Handlebars);
});